module.exports = __webpack_public_path__ + "img/1958-4.46ad3939.png";